export enum StepperTypeAttributes {
  STEPPER_STEPS = 'stepperSteps',
  NAVIGATION_STEPS = 'tabNavigationSteps',
}
